require('./bootstrap');

import moment from 'moment';
import store from './app/store';

import CORE from "./app/libs/core";
import {ConfirmMe} from "./app/libs/confirm_imc";

require('./vue_core/vue_core');

window._core = new CORE();
window.confirm_me = ConfirmMe;
window.moment = moment;

store.dispatch('common/LOAD_SERVICE');
store.dispatch('user/LOAD_USER');


EventBus.$on("reload_user",e => {
    store.dispatch('user/LOAD_USER');
});

EventBus.$on('new_order_in',order => {
    initApp.playSound("/notif_sound",'go_order');

    EventBus.$emit('show_toast', {
        err: order.provider_in_txt + ":" + order.order_code + ", PAY:" + order.price,
        type: "ok",
        title: "New Order : " + order.order_code
    })
});


EventBus.$on("reload_full_user",e => {
    store.dispatch('user/LOAD_FULL_USER');
});

require('./app/sys/index.js');
require('./mount/mount_block.js')



